import { useEffect, useState } from "react";
import { contactInfo, getProfile, PhoneVerifyPost } from "../../services/auth";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import isEmpty from "../../lib/isEmpty";
import { contactInfoAuth } from "../../validation/companyprofile";
import Modal from "react-bootstrap/Modal";
import editicon from "../../assests/images/edit-icon.png";
import { toastError, toastSuccess } from "../../config/ToastModal";
import { useNavigate } from "react-router-dom";

const initialFormValue = {
  country: "",
  state: "",
  city: "",
  address: "",
  website: "",
  phoneNo: "",
};

const ContactInfoBox = ({ contactData, servicesList, setServicesList }) => {
  const navigate = useNavigate();
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [formValue, setFormValue] = useState(initialFormValue);
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");
  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [otp, setOTP] = useState("");
  const { country, state, city, address, website, phoneNo } = formValue;

  const [timer, setTimer] = useState(0);
  const [minutes, setMinutes] = useState(0);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleBlur = ({ target: { name } }) => {
    setTouched({ ...touched, [name]: true });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        country,
        state,
        city,
        address,
        website,
        phoneNo,
      };

      const { status, message, errors } = await contactInfo(data);
      if (status == true) {
        toastSuccess(message);
      } else if (status == false && message) {
        toastError(message);
      } else if (errors) {
        setErrors(errors);
      }
    } catch (err) {}
  };

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, []);

  useEffect(() => {
    if (contactData?.country) {
      const selectedCountry = countriesList.find(
        (item) => item.name === contactData?.country
      );
      if (selectedCountry) {
        setCountryId(selectedCountry.id);
        setFormValue((prevValue) => ({
          ...prevValue,
          country: selectedCountry.name,
        }));
        GetState(selectedCountry.id).then((result) => {
          setStateList(result);
          if (contactData?.state) {
            const selectedState = result.find(
              (item) => item.name === contactData?.state
            );
            if (selectedState) {
              setStateId(selectedState.id);
              setFormValue((prevValue) => ({
                ...prevValue,
                state: selectedState.name,
              }));
              GetCity(selectedCountry.id, selectedState.id).then((result) => {
                setCityList(result);
                if (contactData?.city) {
                  const selectedCity = result.find(
                    (item) => item.name === contactData?.city
                  );
                  if (selectedCity) {
                    setCityId(selectedCity.id);
                    setFormValue((prevValue) => ({
                      ...prevValue,
                      city: selectedCity.name,
                    }));
                  }
                }
              });
            }
          }
        });
      }
    }
  }, [contactData, countriesList]);

  const handleCountryChange = (e) => {
    const selectedCountry =
      countriesList && countriesList.find((item) => item.id == e.target.value);
    setCountryId(selectedCountry.id);
    setFormValue((prevValue) => ({
      ...prevValue,
      country: selectedCountry.name,
      state: "",
      city: "",
    }));
    GetState(selectedCountry.id).then((result) => {
      setStateList(result);
      setCityList([]); // Clear city list when country changes
    });
  };

  const handleStateChange = (e) => {
    const selectedState =
      stateList && stateList.find((item) => item?.id == e.target.value);
    setStateId(selectedState.id);
    setFormValue((prevValue) => ({
      ...prevValue,
      state: selectedState.name,
      city: "",
    }));
    GetCity(countryId, selectedState.id).then((result) => {
      setCityList(result);
    });
  };

  const handleCityChange = (e) => {
    const selectedCity =
      cityList && cityList.find((item) => item?.id == e.target.value);
    setCityId(selectedCity.id);
    setFormValue((prevValue) => ({
      ...prevValue,
      city: selectedCity.name,
    }));
  };

  useEffect(() => {
    setFormValue((prevValue) => ({
      ...prevValue,
      address: contactData?.address,
      city: contactData?.city,
      country: contactData?.country,
      phoneNo: contactData?.phoneNo || servicesList?.phoneNo,
      state: contactData?.state,
      website: contactData?.website,
    }));
  }, [contactData]);

  useEffect(() => {
    const checkValidation = contactInfoAuth(formValue);
    if (!checkValidation.status) {
      setErrors(checkValidation.errors);
    } else {
      setErrors({});
    }
  }, [formValue]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }

      if (timer === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setTimer(30);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timer, minutes]);

  const validateOtp = () => {
    const otpRegex = /^\d{6}$/;

    if (otp?.length > 0) {
      if (!otpRegex.test(otp)) {
        toastError("OTP must be 6 digits long and contain only numbers");
        return false;
      }
      return true;
    } else {
      toastError("Please enter the OTP");
    }
  };

  const verifyOTP = async () => {
    try {
      if (validateOtp()) {
        const data = {
          otp: otp,
          phoneNo: phoneNo,
          phoneStatus: true,
        };
        const response = await PhoneVerifyPost(data);
        if (response?.status === true) {
          toastSuccess(response?.message);
          const responseContact = await getProfile();
          if (responseContact) {
            setServicesList(responseContact?.data);
            handleClose();
          }
        } else {
          toastError(response?.errors?.otp);
        }
      }
    } catch (error) {
      handleShow();
    }
  };

  const getOtp = async () => {
    try {
      if (phoneNo?.length === 10) {
        const data = {
          phoneNo: phoneNo,
          phoneStatus: false,
        };
        const response = await PhoneVerifyPost(data);
        if (response?.status === true) {
          toastSuccess(response?.message);
          handleShow();
          setTimer(30);
        } else {
          toastError(response?.errors?.otp);
        }
      } else {
        toastError("Phone number is required");
      }
    } catch (error) {
      handleShow();
    }
  };

  const resendOtp = () => {
    setMinutes(0);
    setTimer(30);
    getOtp();
  };

  const AddNewMobileNo = () => {
    navigate("/Addnew-Mobile");
  };

  return (
    <div className="default-form">
      <div className="row">
        <div className="form-group col-lg-6 col-md-12">
          <label>
            Country <span className="text-danger">*</span>
          </label>
          <select
            name="country"
            onChange={handleCountryChange}
            value={countryId}
            onBlur={handleBlur}
          >
            <option value="" disabled>
              Select country
            </option>
            {countriesList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {touched?.country && (
            <span className="text-danger">{errors.country}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            State <span className="text-danger">*</span>
          </label>
          <select
            name="state"
            onChange={handleStateChange}
            value={stateId}
            onBlur={handleBlur}
          >
            <option value="" disabled>
              Select state
            </option>
            {stateList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {touched?.state && (
            <span className="text-danger">{errors.state}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            City <span className="text-danger">*</span>
          </label>
          <select
            name="city"
            onChange={handleCityChange}
            value={cityId}
            onBlur={handleBlur}
          >
            <option value="" disabled>
              Select city
            </option>
            {cityList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {touched?.city && <span className="text-danger">{errors.city}</span>}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Website <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="website"
            placeholder="eg www.google.com"
            value={website}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched?.website && (
            <span className="text-danger">{errors.website}</span>
          )}
        </div>

        <div className="form-group col-lg-12 col-md-12">
          <label>
            Address for Reporting <span className="text-danger">*</span>
          </label>
          {/* <input
            type="text"
            name="address"
            placeholder="eg Chennai - 600078."
            value={address}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{
              height:"100px"
            }}
          /> */}
          <textarea
            type="text"
            name="address"
            placeholder="eg Chennai - 600078."
            value={address}
            onChange={handleChange}
            onBlur={handleBlur}
          ></textarea>
          {touched?.address && (
            <span className="text-danger">{errors.address}</span>
          )}
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <label>
            Email ID <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            name="email"
            placeholder="Your Email ID"
            value={servicesList?.email}
            disabled
          />
        </div>

        {servicesList?.phoneStatus == "unverified" &&
        servicesList?.userType == "google" ? (
          <>
            <div className="form-group col-lg-6 col-md-12">
              <div className="d-flex align-items-center gap-2 w-100">
                <div>
                  <label>
                    Phone Number <span className="text-danger">*</span>
                    <span className="text-danger"> (✖ Not Verified)</span>
                  </label>
                  <input
                    type="text"
                    name="phoneNo"
                    placeholder="Enter your number"
                    value={phoneNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={10}
                  />
                  {touched?.phoneNo && (
                    <span className="text-danger">{errors.phoneNo}</span>
                  )}
                </div>
                <div>
                  {servicesList?.phoneStatus == "unverified" &&
                  phoneNo?.length > 9 ? (
                    <>
                      <button
                        className="mt-4 theme-btn btn-style-one"
                        onClick={getOtp}
                      >
                        Get OTP
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="form-group col-lg-6 col-md-12">
              <div>
                <div className="d-flex justify-content-between">
                  <label>
                    Phone Number <span className="text-danger">*</span>
                    <span className="text-success fw-bold"> (✔ Verified)</span>
                  </label>
                  {/* <span
                    onClick={AddNewMobileNo}
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      objectFit: "contain",
                      border: "2px solid #97144d",
                      padding: "2px",
                    }}
                  >
                  
                    <i class="fa-solid fa-pen"></i>
                  </span> */}
                </div>
                <input
                  type="text"
                  name="phoneNo"
                  placeholder="Enter your number"
                  value={phoneNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={10}
                  disabled
                />
                {touched?.phoneNo && (
                  <span className="text-danger">{errors.phoneNo}</span>
                )}
              </div>
            </div>
          </>
        )}

        {/* <div className="form-group col-lg-4 col-md-12">
          
              <label>Verify OTP</label>
              <div className="d-flex align-items-center justify-content-center mt-2 gap-3">
                <div>
                  <input
                    type="text"
                    name="otp"
                    placeholder="Enter your OTP"
                    value={otp}
                    onChange={(e) => setOTP(e.target.value)}
                    maxLength={4}
                  />
                </div>
                <div>
                  <button
                    className="theme-btn btn-style-one"
                    onClick={otpVerify}
                  >
                    Verify OTP
                  </button>
                </div>
              </div>
         
        </div> */}

        <div className="form-group col-lg-12 col-md-12 d-flex align-items-center justify-content-center w-100">
          <button
            type="submit"
            className="theme-btn btn-style-one"
            style={!isEmpty(errors) ? { cursor: "not-allowed" } : {}}
            disabled={!isEmpty(errors)}
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>OTP Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-2 mb-4">
            <label>OTP</label>
            <div>
              <input
                type="text"
                placeholder="Enter Your OTP"
                style={{
                  width: "100%",
                  padding: "15px",
                  borderRadius: "10px",
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  background: "white",
                }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => setOTP(e.target.value)}
                maxLength={6}
              />
            </div>

            <div className="mt-4">
              <button
                className="w-100 theme-btn btn-style-one"
                onClick={verifyOTP}
              >
                Verify
              </button>
            </div>

            <div className="mt-3">
              {minutes === 0 && timer === 0 ? (
                <>
                  <div className="text-center mt-3">
                    Not received your code?{" "}
                    <span
                      onClick={resendOtp}
                      className="text-danger cursor"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      Resend code
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center mt-3">
                    Not received your code?{" "}
                    <span className="text-danger">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {timer < 10 ? `0${timer}` : timer}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ContactInfoBox;
